import { makeQuery } from "src/queries/makeQuery";
import type { User, UserPublic } from "src/queries/users/users.types";

const defaultUsersSelect = (users: User[]): User[] => {
  if (users && users.length > 0) {
    return [...users].sort((a, b) => a.user_id - b.user_id);
  }
  return [];
};

export const useQueryUsers = makeQuery<User[], User[]>("/api/users", {
  select: defaultUsersSelect,
});

const defaultUsersPublicSelect = (users: UserPublic[]): UserPublic[] => {
  if (users && users.length > 0) {
    return [...users].toSorted((a, b) => a.user_id - b.user_id);
  }
  return [];
};

export const useQueryUsersPublic = makeQuery<UserPublic[], UserPublic[]>(
  "/api/users/public",
  {
    select: defaultUsersPublicSelect,
  }
);
